import React, { useState } from 'react'
import { Card, CardContent } from '../ui/card'
import { Input } from '../ui/input'
import { Button } from '../ui/button'
import '../../assets/styleSheets/viewRequest.scss'
import { goToHomePage } from '../../helpers/Utils'
import { IconPlus, IconTrash } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'

export default function ViewRequestActiveStep3 (props) {
  const {
    partDealersList,
    errors,
    onStep3CTA,
    handleDealerSelection,
    selectedDealers,
    // isLoading,
    handleInputChange,
    inputValue,
    handleAddFields,
    handleRemoveFields,
    handleInputChangeForNewPartDealer,
    onSkipStep3,
    discardAdditionalPartDealers
  } = props

  const [addSupplier, setAddSupplier] = useState(false)
  const { t } = useTranslation(['viewRequest'])

  return (
    <div className='login-container'>
      {addSupplier ? (
        <>
          <div className='logo' onClick={goToHomePage} />
          <Card className='login-card p-8'>
            <CardContent
              style={{
                height: 'auto',
                minWidth: '717px'
              }}
              className='login-right'
            >
              <h2 className='font-weight-700 gp-text24 tracking-0 gp-lh28 gp-mb8 gp-mt8'>
                Mehr Teilelieferanten hinzufügen
              </h2>
              <p className='subheading'>Configure now to order directly.</p>
              <div
                style={{
                  gap: '16px',
                  display: 'flex',
                  flexDirection: 'column'
                }}
                className='h-[400px] overflow-auto'
              >
                {inputValue?.map((inputField, index) => (
                  <div
                    key={`addpds_${index}`}
                    style={{
                      border: '1px solid #D9D9E0',
                      borderRadius: '8px',
                      padding: '16px',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'flex-end'
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px',
                        width: '40%'
                      }}
                    >
                      <span
                        style={{
                          fontWeight: '600',
                          fontSize: '14px',
                          color: '#1C2024'
                        }}
                      > 
                        {t('partSupplierName')}
                      </span>
                      <Input
                        placeholder='Max Mustermann Teileservice'
                        variant='outlined'
                        size='medium'
                        required
                        value={inputField.partSupplier}
                        onChange={(e) =>
                          handleInputChangeForNewPartDealer(index, e)}
                        name='partSupplier'
                      />
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px',
                        width: '40%'
                      }}
                    >
                      <span
                        style={{
                          fontWeight: '600',
                          fontSize: '14px',
                          color: '#1C2024'
                        }}
                      >
                        {t('customerId')}
                      </span>
                      <Input
                        placeholder='12345'
                        variant='outlined'
                        size='medium'
                        required
                        value={inputField.customerNo}
                        onChange={(e) =>
                          handleInputChangeForNewPartDealer(index, e)}
                        name='customerNo'
                      />
                    </div>
                    {inputValue?.length > 1 &&
                    (<div
                      style={{
                        backgroundColor: '#F0F0F3',
                        padding: '6px',
                        borderRadius: '8px'
                      }}
                      onClick={() => handleRemoveFields(index)}
                    >
                      <IconTrash size={24} color='#1C2024' />
                    </div>)}
                  </div>
                ))}
              </div>
              <div
                style={{
                  display: 'flex',
                  paddingTop: '24px',
                  alignItems: 'center',
                  gap: '4px',
                  cursor: 'pointer'
                }}
                onClick={handleAddFields}
              >
                <IconPlus height={16} width={16} color='#6926D9' />
                <span
                  style={{
                    fontWeight: '500',
                    fontSize: '14px',
                    color: '#6926D9'
                  }}
                >
                  Mehr Teilelieferanten hinzufügen
                </span>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: '16px',
                  paddingTop: '24px'
                }}
              >
                <Button
                  onClick={() => {
                    discardAdditionalPartDealers()
                    setAddSupplier(false)
                  }}
                  style={{
                    backgroundColor: 'transparent',
                    border: '1px solid #00002F29',
                    borderRadius: '8px',
                    padding: '6px 8px',
                    fontWeight: '500',
                    fontSize: '14px',
                    color: '#1C2024'
                  }}
                >
                  Discard
                </Button>
                <Button
                  onClick={() => setAddSupplier(false)}
                  style={{
                    backgroundColor: '#6926D9',
                    borderRadius: '8px',
                    padding: '6px 8px',
                    fontWeight: '500',
                    fontSize: '14px',
                    color: '#F6F5FE'
                  }}
                >
                  Add selected
                </Button>
              </div>
            </CardContent>
          </Card>
        </>
      ) : (
        <>
          <div className='logo' onClick={goToHomePage} />
          <Card className='login-card p-8'>
            <CardContent
              style={{
                height: 'auto',
                minWidth: '717px'
              }}
              className='login-right'
            >
              <span
                style={{
                  fontWeight: '400',
                  fontSize: '12px',
                  lineHeight: '16px',
                  color: '#60646C',
                  backgroundColor: '#E8E8EC',
                  borderRadius: '6px',
                  padding: '2px 4px'
                }}
              >
                STEP 2 OF 2
              </span>
              <h2 className='font-weight-700 gp-text24 tracking-0 gp-lh28 gp-mb8 gp-mt8'>
                Ihre Teilelieferanten
              </h2>
              <p className='subheading'>
                Jetzt konfigurieren um direkt zu bestellen
              </p>
              <div className='h-[400px] overflow-auto'>
                <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4'>
                  {partDealersList.map((dealer, index) => {
                    const isSelected = selectedDealers.some(
                      (selectedDealer) =>
                        selectedDealer.part_dealer_id === dealer.id
                    )
                    const error = errors[dealer.id]

                    return (
                      <div
                        key={index}
                        className={`text-center cp seller_logo ${
                          isSelected ? 'selected-seller' : 'br_1'
                        }`}
                        style={{
                          padding: '8px',
                          backgroundColor: '#FFFFFF',
                          borderRadius: '10px',
                          alignItems: 'center',
                          justifyContent: 'center',
                          display: 'flex',
                          flexDirection: 'column'
                        }}
                      >
                        {dealer?.logo_url
                          ? (
                            <img
                              src={dealer?.logo_url}
                              alt={`Dealer ${dealer.part_dealer_id}`}
                              height='120px'
                              width='120px'
                              onClick={() => handleDealerSelection(dealer.id)}
                            />
                            )
                          : (
                            <div
                              style={{
                                height: '120px',
                                width: '120px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: '5px'
                              }}
                              onClick={() => handleDealerSelection(dealer.id)}
                              className='break-word'
                            >
                              {dealer?.name}
                            </div>
                            )}
                        <Input
                          placeholder='Kunden-Nr.'
                          variant='outlined'
                          size='medium'
                          required
                          value={
                            selectedDealers.find(
                              (selectedDealer) =>
                                selectedDealer.part_dealer_id === dealer.id
                            )?.part_dealer_customer_number || ''
                          }
                          onChange={(e) =>
                            handleInputChange(dealer.id, e.target.value)}
                          fullWidth
                          margin='normal'
                          style={{
                            width: '120px',
                            border: !!error && '1px solid red'
                          }}
                          error={!!error}
                          helperText={error}
                        />
                      </div>
                    )
                  })}
                  {inputValue?.map((inputField, index) => (
                    <div
                      key={index}
                      className='text-center cp seller_logo'
                      style={{
                        padding: '8px',
                        backgroundColor: '#FFFFFF',
                        borderRadius: '10px',
                        border: '1px solid #6926d9',
                        alignItems: 'center',
                        justifyContent: 'center',
                        display: 'flex',
                        flexDirection: 'column'
                      }}
                    >
                      <div
                        style={{
                          height: '120px',
                          width: '120px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          padding: '5px'
                        }}
                        // onClick={() => handleDealerSelection(dealer.id)}
                        className='break-word'
                      >
                        {inputField?.partSupplier}
                      </div>
                      <Input
                        placeholder='Kunden-Nr.'
                        variant='outlined'
                        size='medium'
                        required
                        value={inputField?.customerNo}
                        onChange={(e) =>
                          handleInputChangeForNewPartDealer(index, e)}
                        name='customerNo'
                        fullWidth
                        margin='normal'
                        style={{
                          width: '120px'
                        }}
                      />
                    </div>
                  ))}
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  gap: '4px',
                  paddingTop: '24px',
                  alignItems: 'center'
                }}
              >
                <span
                  style={{
                    fontWeight: '400',
                    size: '14px',
                    color: '#60646C'
                  }}
                >
                  Ihr Lieferant ist nicht in der Liste?
                </span>
                <span
                  style={{
                    fontWeight: '500',
                    fontSize: '14px',
                    color: '#6926D9'
                  }}
                  onClick={() => {
                    handleAddFields()
                    setAddSupplier(true)
                  }}
                >
                  Weitere Lieferanten hinzufügen
                </span>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: '16px',
                  paddingTop: '24px'
                }}
              >
                <Button
                  onClick={onSkipStep3}
                  style={{
                    backgroundColor: 'transparent',
                    border: '1px solid #00002F29',
                    borderRadius: '8px',
                    padding: '6px 8px',
                    fontWeight: '500',
                    fontSize: '14px',
                    color: '#1C2024'
                  }}
                >
                  Überspringen und später einrichten
                </Button>
                <Button
                  onClick={onStep3CTA}
                  style={{
                    backgroundColor: '#6926D9',
                    borderRadius: '8px',
                    padding: '6px 8px',
                    fontWeight: '500',
                    fontSize: '14px',
                    color: '#F6F5FE'
                  }}
                >
                  Weiter
                </Button>
              </div>
            </CardContent>
          </Card>
        </>
      )}
    </div>
  )
}